import type { default as Palette } from 'diagram-js/lib/features/palette/Palette';
import type { default as ElementFactory } from 'diagram-js/lib/core/ElementFactory';
import type { default as Create } from 'diagram-js/lib/features/create/Create';
import type {
    default as IPaletteProvider,
    PaletteEntry,
    PaletteEntryAction,
    PaletteEntriesCallback,
} from 'diagram-js/lib/features/palette/PaletteProvider';

class PaletteProvider implements IPaletteProvider {
    public static readonly $inject: string[] = ['create', 'elementFactory', 'palette', 'translate'];

    private readonly _create: Create;
    private readonly _elementFactory: ElementFactory;
    private readonly _translate: TranslateFn;

    constructor(
        create: Create,
        elementFactory: ElementFactory,
        palette: Palette,
        translate: TranslateFn
    ) {
        this._create = create;
        this._elementFactory = elementFactory;
        this._translate = translate;
        palette.registerProvider(this);
    }

    public getPaletteEntries() {
        return this.getEntries;
    }

    private readonly getEntries: PaletteEntriesCallback = (entries) => {
        // delete entries
        entryKeysToDelete.forEach((key) => {
            delete entries[key];
        });

        // map entries
        return Object.fromEntries(
            Object.entries(entries).map((entry) => {
                // map create.task entry to create.user-task

                if (isTaskEntry(entry)) {
                    //return this.mapTaskToUserTask(entry);
                }

                return entry;
            })
        );
    };

    private readonly mapTaskToUserTask = (entry: TaskEntry): AnyEntry => [
        'create.user-task',
        {
            ...entry[1],
            className: 'bpmn-icon-user-task',
            title: this._translate('Create User Task'),
            action: {
                dragstart: this.userTaskAction,
                click: this.userTaskAction,
            },
        },
    ];

    private readonly userTaskAction: PaletteEntryAction = (event) => {
        this._create.start(event, this._elementFactory.createShape({ type: 'bpmn:UserTask' }));
    };
}

const entryKeysToDelete = [
    'create.data-object',
    'create.data-store',
    'create.participant-expanded',
    // 'create.task',
];

type AnyEntry<K extends string = string> = [K, PaletteEntry];
type TaskEntry = AnyEntry<'create.task'>;

const isTaskEntry = (entry: AnyEntry): entry is TaskEntry => entry[0] === 'create.task';

export default PaletteProvider;
